import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// css
import "./atcRoster.css"
import check from "../../../../assets/images/check.png";
import cross from "../../../../assets/images/remove.png"
// mui
import Tables from "components/table/table";
// import rpRosterAPI from "apis/panel/rpRoster/rpRadRoster";
import poolPrepRosterAPI from "apis/panel/PoolPrepRoster/poolPrepRoster";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";
import Box from '@mui/material/Box';
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Fade from '@mui/material/Fade';

import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';

import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { Button } from "../../../../../node_modules/@mui/material/index";
// import EditRadRoster from "./EditPoolPrepRoster";
// import EditPoolPrepRoster from "./EditPoolPrepRoster";
import EditAtcRoster from "./EditAtcRoster";
import atcRosterAPI from "apis/panel/ATCRoster/atcRoster";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgb(83 83 83)',
    color: 'white',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
  },
  "& .MuiTooltip-arrow": {
    color: "rgb(83 83 83)",         
  },
}));

const AtcRoster = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();

  const { getAllAtcRosterDetailsAPI } = atcRosterAPI()

  const [atcRosterDetails, setAtcRosterDetails] = useState([])
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
  // const [radRosterEditObj, setRadRosterEditObj] = useState([]);
  const [editId, setEditId] = useState('')
  const [open, setOpen] = useState(false);

  const [serialNumber, setSerialNumber] = useState("");


  const handleEdit = async (id) => {

    setOpen(true)

    setEditId(id)
  }

  const handleNavigate = () => {
    navigate("/panel/addAtcRoster")
  }

  const handleNavigation = () => {
    navigate("/panel/rpHomePage")
  }

  const handleClose = async () => {
    setEditId('')
    setOpen(false)
  }

  const handleGetAllAtcRosterDetailsApi = async () => {


    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20,
      };
      if (searchValue) {
        values = {
          ...values,
          searchValue,
        };
      }
      if (filterValue) {
        values = {
          ...values,
          filterValue,
        };
      }
      let res = await getAllAtcRosterDetailsAPI(values);

      setAtcRosterDetails(res?.data?.atcRosters || []);
      setCount(res?.data?.count);
      setSerialNumber(offset)
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  useEffect(() => {

    handleGetAllAtcRosterDetailsApi()

  }, [offset, searchValue, filterValue, open])

  

  return (
    <div
      className="vraShiftsMediaQuery"
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <Tables
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
              <img src={leftarrow} alt="Back" />
            </div>
            <Box sx={{ pt: 2, pb: 2 }} className="VraShiftsTitle">
              ATC Roster
            </Box>
          </div>
        }
        searchBar={true}
        filter={false}
        role={roleCode}
        create={

          <Button className="AddEmployerButton" onClick={handleNavigate}>
            Add
          </Button>
        }
        setSearchValue={setSearchValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterValues={[
          { label: "Region", value: "" },
          { label: "Practice", value: "practice" },
        ]}
        heading={[
          "S.No",
          "Region",
          "Practice",
          "RP Projection Date",
          "Go-Live Date",
          "Assignment Type",
          "No of ATC Support",
          "Coverage Duration",
          "Shift Pattern",
          "Handled By VRA",
          "Handled By RP",
          "Remarks",
          // "Is Active",
          "Actions"

        ]}
        data={atcRosterDetails?.map((e, index) => [

          index + 1 + (serialNumber - 1) * 20,

          e.region,
          e.practice,
          e.projection_date ? moment(e.projection_date).format('DD-MMM-YYYY') : e.projection_date,
          e.go_live_date ? moment(e.go_live_date).format('DD-MMM-YYYY') : e.go_live_date,
          e.assignment_type,
          e.no_of_atc_support,
          e.coverage_duration,
          e.shift_pattern,
          e.vra_fullname,
          e.handled_by_rp,
          e.remarks,
          // e.is_active ? (
          //   <img style={{ height: "20px" }} src={check} alt="" />
          // ) : (
          //   <img style={{ height: "20px" }} src={cross} alt="" />
          // ),

          <EditIcon style={{ color: "#FE6024", cursor: 'pointer' }} onClick={() => handleEdit(e.atc_roster_id)} />,
        ])}
        offset={offset}
        setOffset={setOffset}
        limit={20}
        count={count}
        placeholder="Search by Region,Practice"
      />

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title"
        aria-describedby="modal-description" >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: 460,
          overflowY: 'scroll',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '10px',

          p: 4,
        }} >
          <EditAtcRoster id={editId} onClose={handleClose} />
        </Box>
      </Modal>

    </div>
  )
}


export default AtcRoster